import { useState } from 'react';
import { LoadMoreItemsArgs } from 'types/SearchData.types';
import useFetch from '../../src/hooks/useFetch';

type GetUrlArgs = {
  pageNumber: number;
  limit: number;
  searchTerm?: string;
  searchRegion: string;
  date: Date;
  endPoint: string;
  value?: string;
};

interface LoadKudosDataHook {
  getURL: (arg: GetUrlArgs) => any;
  date: Date;
  endPoint: string;
  value?: string;
}

type LoadMoreArgs = {
  monthDate: Date;
  skipLoading?: boolean;
  searchText?: string;
  searchRegion?: string;
};

interface UseLoadKudos {
  leaderboardItems: any;
  isLoading: boolean;
  page: number;
  onLoadMoreItems: any;
  leaderboardDate: Date;
  loadMonthData: any;
  resetSearch: boolean;
  error: Error;
}

export const useLoadKudosData = ({
  getURL,
  date: initialDate = new Date(),
  endPoint = 'receivers',
  value,
}: LoadKudosDataHook): UseLoadKudos => {
  const [searchTerm, setSearchTerm] = useState('');
  const [resetSearch, setResetSearch] = useState(false);
  const [leaderboardDate, setLeaderboardDate] = useState(new Date(initialDate));
  const [page, setPage] = useState(1);
  const { dataAPI: leaderboardItems, isLoading, fetchApi, error } = useFetch();

  const loadMonthData = async ({
    monthDate,
    skipLoading = false,
    searchText = '',
    searchRegion = '',
  }: LoadMoreArgs) => {
    if (skipLoading) {
      return setLeaderboardDate(monthDate);
    }
    const url = getURL({
      pageNumber: 1,
      limit: 20,
      searchTerm: searchText,
      searchRegion,
      date: monthDate,
      endPoint,
      value,
    });
    await fetchApi(url);
    setSearchTerm('');
    setResetSearch(!resetSearch);
    setLeaderboardDate(monthDate);
    setPage(1);

    return null;
  };

  const onLoadMoreItems = async ({
    pageNumber,
    limit,
    searchRegion = '',
    searchTerm: searchText,
  }: LoadMoreItemsArgs) => {
    let search = searchTerm;

    if (searchText !== undefined && searchText !== searchTerm) {
      search = searchText;
      setSearchTerm(searchText);
    }
    const url = getURL({
      pageNumber,
      limit,
      searchTerm: search,
      searchRegion,
      date: leaderboardDate,
      endPoint,
      value,
    });
    await fetchApi(url);
    setPage(pageNumber);
  };

  return {
    leaderboardItems,
    isLoading,
    page,
    onLoadMoreItems,
    leaderboardDate,
    loadMonthData,
    resetSearch,
    error,
  };
};
